var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_587",
    "data-name": "Groupe 587",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "#339dff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 15,
    cy: 15,
    r: 15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-swap",
    "data-name": "Icon ionic-ios-swap",
    transform: "translate(7.058 26.699) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_124",
    "data-name": "Trac\\xE9 124",
    d: "M9.975,8.482a.678.678,0,0,1-.005-.961l2.466-2.5H.679a.679.679,0,1,1,0-1.359H12.431l-2.466-2.5A.68.68,0,0,1,10.931.2l3.605,3.658h0a.665.665,0,0,1,.141.214.648.648,0,0,1,.052.261.681.681,0,0,1-.193.475L10.931,8.467A.672.672,0,0,1,9.975,8.482Z",
    transform: "translate(8.669)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_125",
    "data-name": "Trac\\xE9 125",
    d: "M4.755,8.482a.678.678,0,0,0,.005-.961L2.3,5.018H14.05a.679.679,0,0,0,0-1.359H2.3l2.466-2.5A.68.68,0,0,0,3.8.2L.193,3.858h0a.665.665,0,0,0-.141.214A.648.648,0,0,0,0,4.334a.681.681,0,0,0,.193.475L3.8,8.467A.672.672,0,0,0,4.755,8.482Z",
    transform: "translate(0 7.211)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.db3ba6d9.svg";
export { ForwardRef as ReactComponent };